module.exports = __webpack_public_path__ + "static/media/t.82080889.svg";